// extracted by mini-css-extract-plugin
export default {"white_border":"PromotionGroup_white_border__+7Kcg"};